/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './intra-op-count.reducer';

export const IntraOPCountDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const intraOPCountEntity = useAppSelector(state => state.intraOPCount.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="intraOPCountDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.intraOPCount.detail.title">IntraOPCount</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.id">Id</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.id}</dd>
          <dt>
            <span id="countType">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.countType">Count Type</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.countType}</dd>
          <dt>
            <span id="sponges">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.sponges">Sponges</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.sponges}</dd>
          <dt>
            <span id="gauze">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.gauze">Gauze</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.gauze}</dd>
          <dt>
            <span id="peanut">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.peanut">Peanut</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.peanut}</dd>
          <dt>
            <span id="cottonoid">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.cottonoid">Cottonoid</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.cottonoid}</dd>
          <dt>
            <span id="vesselLoop">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.vesselLoop">Vessel Loop</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.vesselLoop}</dd>
          <dt>
            <span id="rollerGauze">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.rollerGauze">Roller Gauze</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.rollerGauze}</dd>
          <dt>
            <span id="instrument">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.instrument">Instrument</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.instrument}</dd>
          <dt>
            <span id="needle">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.needle">Needle</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.needle}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.active">Active</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{intraOPCountEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPCount.nursingRecord">Nursing Record</Translate>
          </dt>
          <dd>{intraOPCountEntity.nursingRecord ? intraOPCountEntity.nursingRecord.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/intra-op-count" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/intra-op-count/${intraOPCountEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IntraOPCountDetail;
